import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { getFinOnArrivalData } from "../../../../store/Api";
import FinListDataOnArrivalMedical from "./FinListDataOnArrivalMedical";

export default function FinOnArrivalMedical() {
    const Client = useSelector((state) => state.finOnArrivalData);
    //screen Title Show fun
    const dispatch = useDispatch();
    const titleBorder = [{ label: 'ON ARRIVAL MEDICAL', link: '/dashboard/OnArrivalMedical' }];
    useEffect(() => {
        dispatch(setBreadCrumb(titleBorder));
        dispatch(getFinOnArrivalData(token));
    }, []);

    const updateList = () => {
        dispatch(getFinOnArrivalData(token));
    }
    // get DAta
    const token = localStorage.getItem("nodeToken");




    return (
        <>
            <div className={`ml-5 mr-5`}>
                <div>
                    <FinListDataOnArrivalMedical
                        list={Client}
                        titles={[
                            "S.NO.",
                            "EMPLOYEE ID",
                            "VISA PROVIDER",
                            "Client Name",
                            "SPONSOR ID",
                            "EMPLOYEE NAME",
                            "VISA REFERENCE NUMBER",
                            'VISA STAMPING DATE',
                            'VISA BLOCK NUMBER',
                            'BORDER NUMBER',
                            'PASSPORT NUMBER',
                            'ON ARRIVAL MEDICAL APPLICATION DATE',
                            'ON ARRIVAL MEDICAL STATUS',
                            'ON ARRIVAL MEDICAL STATUS DATE',
                            'ON ARRIVAL MEDICAL DEPENDENCY',
                            'ACTUAL FEE PAID',
                            "Action"
                        ]}
                        token={token}
                        updateList={updateList}
                    />
                </div>
            </div>
        </>
    );
}